import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "DatetimeIntlFormatters"*/ './lazyIndex'),
    { name: 'DatetimeIntlFormatters' }
);

export const lazyFormatIntlDate: LazyAction<typeof lazyIndex.formatIntlDate, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.formatIntlDate);

export const lazyGetIntlMonth: LazyAction<typeof lazyIndex.getIntlMonth, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getIntlMonth);

export const lazyGetIntlYear: LazyAction<typeof lazyIndex.getIntlYear, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getIntlYear);
